import { isFullscreen, setFullscreen } from '../../modules/player';

export default function fullscreen(store, translator) {
  return {
    enabled: true,
    display: true,
    options: {},

    isActive: isFullscreen,

    activate: () => {
      const playerEl = store.getIn(['player', 'playerElement']);
      ['requestFullscreen', 'webkitRequestFullscreen', 'mozRequestFullScreen', 'msRequestFullscreen'].forEach(function (fn) {
        if (playerEl[fn]) return playerEl[fn]();
      });

      store.dispatch(setFullscreen(true));
    },

    deactivate: () => {
      ['exitFullscreen', 'webkitExitFullscreen', 'mozCancelFullScreen', 'msExitFullscreen'].forEach(function (fn) {
        if (document[fn]) return document[fn]();
      });

      store.dispatch(setFullscreen(false));
    },
  };
}



// WEBPACK FOOTER //
// ./src/translators/tools/fullscreen.js